import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import { ROUTE_PATHS } from '@acorn-portal/shared/src/utils/Routes';
import { useRejectCancellation } from '../use-reject-cancellation';
import { useAppSelector } from '../../../../hooks/reduxHook';

/**
 * Hook for leaving the cancellation journey _imperatively_ via a user action (e.g. via a button click on the Leave modal).
 */
export const useLeaveCancellation = () => {
	const navigate = useNavigate();
	const isLeaving = useAppSelector((state) => state.cancellation.rejectStatus.isLoading);
	const { rejectAndReset } = useRejectCancellation();

	const handleLeaveCancellation = useCallback(async () => {
		await rejectAndReset();
		navigate(ROUTE_PATHS.home);
	}, [rejectAndReset, navigate]);

	return {
		handleLeaveCancellation,
		isLeaving,
	};
};
